import { Formik } from 'formik';
import { useSelector } from 'react-redux';

import FormWrapper from '~FormWrapper';
import { useExamRooms } from '~hooks/useExamRooms';
import StudyRoomCleanForm from './StudyRoomCleanForm';
import { useOnSubmit, useOnEdit } from '~hooks';
import { removeEmptyKeys } from '../validations';

const StudyRoomClean = props => {
  const { formId, edit } = props;

  const contactPhone = useSelector(state => state.user?.data?.phone);

  const rooms = useExamRooms();

  const validate = values => {
    const errors = {};

    if (!values.room) {
      errors.room = 'Vaadittu';
    }

    if (values.precautions === 'YES' && !values.precautionClass) {
      errors.precautionClass = 'Vaadittu';
    }

    return removeEmptyKeys(errors);
  };

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={{
        room: null,
        urgency: 'URGN',
        precautions: 'NO',
        precautionClass: null,
        cleanupTime: null,
        contactPhone: contactPhone || '',
        additionalInfo: '',
      }}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
          },
          setSubmitting,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Tutkimushuoneen siivous"
          formik={formikProps}
          Component={StudyRoomCleanForm}
          rooms={rooms}
        />
      )}
    </Formik>
  );
};

export default StudyRoomClean;
